<template>
  <section>
    <b-button
      size="is-small"
      type="is-primary"
      @click="downloadFile"
      :disabled="disabled"
    >
      <span>{{ $t("DownloadTemplate") }}</span>
      <b-icon icon="file-download"></b-icon>
    </b-button>
  </section>
</template>
<script lang="ts">
import revenueService from "@/services/revenueService";

export default {
  props: ["content", "fileName", "disabled"],
  methods: {
    downloadFile() {
      revenueService.generateFile(this.fileName, this.content);
    },
  },
};
</script>
